import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, errMsg } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = not authed, obj = authed
  const [mustChange, setMustChange] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("spread_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("spread_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (phone, password) => {
    const { data } = await api.post("/auth/login", { phone, password });
    localStorage.setItem("spread_token", data.token);
    setUser(data.user);
    setMustChange(!!data.must_change_password);
    return data;
  };

  const initialize = async (payload) => {
    const { data } = await api.post("/auth/initialize", payload);
    localStorage.setItem("spread_token", data.token);
    setUser(data.user);
    setMustChange(false);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("spread_token");
    setUser(false);
    setMustChange(false);
  };

  const setPasswordChanged = () => {
    setMustChange(false);
    refresh();
  };

  return (
    <AuthContext.Provider value={{ user, mustChange, login, initialize, logout, refresh, setPasswordChanged, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { errMsg };
